<h2 mat-dialog-title>CAMBIAR TUTOR</h2>

<div mat-dialog-content class="content">
  <p class="hint">
    INGRESA EL CORREO DEL NUEVO TUTOR. SI NO EXISTE, PODRAS CREARLO.
  </p>

  <mat-form-field appearance="outline" class="w-100 no-uppercase">
    <mat-label>CORREO ELECTRONICO</mat-label>
    <input matInput [formControl]="emailCtrl" autocomplete="off" />
    <mat-icon matSuffix>mail</mat-icon>
  </mat-form-field>

  <div class="err" *ngIf="emailCtrl.touched && emailCtrl.invalid">
    <small *ngIf="emailCtrl.hasError('required')">EL CORREO ES OBLIGATORIO.</small>
    <small *ngIf="emailCtrl.hasError('pattern')">INGRESA UN CORREO VALIDO.</small>
  </div>
</div>

<div mat-dialog-actions align="end">
  <button mat-button type="button" (click)="cancelar()">CANCELAR</button>
  <button mat-raised-button color="primary" type="button" (click)="aceptar()">
    CONTINUAR
  </button>
</div>
